import {
	// Stock Locations
	GET_ALL_STOCK_LOCATIONS,
	GET_ALL_STOCK_LOCATIONS_SUCCESS,
	GET_STOCK_LOCATION,
	GET_STOCK_LOCATION_SUCCESS,
	ADD_STOCK_LOCATION,
	ADD_STOCK_LOCATION_SUCCESS,
	UPDATE_STOCK_LOCATION,
	UPDATE_STOCK_LOCATION_SUCCESS,
	DELETE_STOCK_LOCATION,
	DELETE_STOCK_LOCATION_SUCCESS,
	// Units of Measurement
	GET_ALL_UNITS_OF_MEASUREMENT,
	GET_ALL_UNITS_OF_MEASUREMENT_SUCCESS,
	GET_UNIT_OF_MEASUREMENT,
	GET_UNIT_OF_MEASUREMENT_SUCCESS,
	ADD_UNIT_OF_MEASUREMENT,
	ADD_UNIT_OF_MEASUREMENT_SUCCESS,
	UPDATE_UNIT_OF_MEASUREMENT,
	UPDATE_UNIT_OF_MEASUREMENT_SUCCESS,
	DELETE_UNIT_OF_MEASUREMENT,
	DELETE_UNIT_OF_MEASUREMENT_SUCCESS,
	// Conversions
	GET_ALL_CONVERSIONS,
	GET_ALL_CONVERSIONS_SUCCESS,
	GET_CONVERSION,
	GET_CONVERSION_SUCCESS,
	ADD_CONVERSION,
	ADD_CONVERSION_SUCCESS,
	UPDATE_CONVERSION,
	UPDATE_CONVERSION_SUCCESS,
	DELETE_CONVERSION,
	DELETE_CONVERSION_SUCCESS,
	// Tax Rates
	GET_ALL_TAX_RATES,
	GET_ALL_TAX_RATES_SUCCESS,
	GET_TAX_RATE,
	GET_TAX_RATE_SUCCESS,
	ADD_TAX_RATE,
	ADD_TAX_RATE_SUCCESS,
	UPDATE_TAX_RATE,
	UPDATE_TAX_RATE_SUCCESS,
	DELETE_TAX_RATE,
	DELETE_TAX_RATE_SUCCESS,
	// Payment Methods
	GET_ALL_PAYMENT_METHODS,
	GET_ALL_PAYMENT_METHODS_SUCCESS,
	GET_PAYMENT_METHOD,
	GET_PAYMENT_METHOD_SUCCESS,
	ADD_PAYMENT_METHOD,
	ADD_PAYMENT_METHOD_SUCCESS,
	UPDATE_PAYMENT_METHOD,
	UPDATE_PAYMENT_METHOD_SUCCESS,
	DELETE_PAYMENT_METHOD,
	DELETE_PAYMENT_METHOD_SUCCESS,
} from "../actions/DefaultValues.action";

const initialState = {
	// Stock Locations
	getAllStockLocationsLoading: false,
	getStockLocationLoading: false,
	addStockLocationLoading: false,
	updateStockLocationLoading: false,
	deleteStockLocationLoading: false,
	stockLocations: [],
	stockLocation: null,
	// Units of Measurement
	getAllUnitsOfMeasurementLoading: false,
	getUnitOfMeasurementLoading: false,
	addUnitOfMeasurementLoading: false,
	updateUnitOfMeasurementLoading: false,
	deleteUnitOfMeasurementLoading: false,
	unitsOfMeasurement: [],
	unitOfMeasurement: null,
	// Conversions
	getAllConversionsLoading: false,
	getConversionLoading: false,
	addConversionLoading: false,
	updateConversionLoading: false,
	deleteConversionLoading: false,
	conversions: [],
	conversion: null,
	// Tax Rates
	getAllTaxRatesLoading: false,
	getTaxRateLoading: false,
	addTaxRateLoading: false,
	updateTaxRateLoading: false,
	deleteTaxRateLoading: false,
	taxRates: [],
	taxRate: null,
	// Payment Methods
	getAllPaymentMethodsLoading: false,
	getPaymentMethodLoading: false,
	addPaymentMethodLoading: false,
	updatePaymentMethodLoading: false,
	deletePaymentMethodLoading: false,
	paymentMethods: [],
	paymentMethod: null,
};

function defaultValues(state = initialState, action) {
	switch (action.type) {
		// Stock Locations
		case GET_ALL_STOCK_LOCATIONS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_STOCK_LOCATIONS_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		case GET_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case GET_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocation: action.payload.stockLocation,
			});
		case ADD_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case ADD_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		case UPDATE_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case UPDATE_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		case DELETE_STOCK_LOCATION:
			return Object.assign({}, state, action.payload);
		case DELETE_STOCK_LOCATION_SUCCESS:
			return Object.assign({}, state, {
				stockLocations: action.payload.stockLocations,
			});
		// Units of Measurement
		case GET_ALL_UNITS_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case GET_ALL_UNITS_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		case GET_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case GET_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitOfMeasurement: action.payload.unitOfMeasurement,
			});
		case ADD_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case ADD_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		case UPDATE_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case UPDATE_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		case DELETE_UNIT_OF_MEASUREMENT:
			return Object.assign({}, state, action.payload);
		case DELETE_UNIT_OF_MEASUREMENT_SUCCESS:
			return Object.assign({}, state, {
				unitsOfMeasurement: action.payload.unitsOfMeasurement,
			});
		// Conversions
		case GET_ALL_CONVERSIONS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_CONVERSIONS_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		case GET_CONVERSION:
			return Object.assign({}, state, action.payload);
		case GET_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversion: action.payload.conversion,
			});
		case ADD_CONVERSION:
			return Object.assign({}, state, action.payload);
		case ADD_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		case UPDATE_CONVERSION:
			return Object.assign({}, state, action.payload);
		case UPDATE_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		case DELETE_CONVERSION:
			return Object.assign({}, state, action.payload);
		case DELETE_CONVERSION_SUCCESS:
			return Object.assign({}, state, {
				conversions: action.payload.conversions,
			});
		// Tax Rates
		case GET_ALL_TAX_RATES:
			return Object.assign({}, state, action.payload);
		case GET_ALL_TAX_RATES_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		case GET_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case GET_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRate: action.payload.taxRate,
			});
		case ADD_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case ADD_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		case UPDATE_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case UPDATE_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		case DELETE_TAX_RATE:
			return Object.assign({}, state, action.payload);
		case DELETE_TAX_RATE_SUCCESS:
			return Object.assign({}, state, {
				taxRates: action.payload.taxRates,
			});
		// Payment Methods
		case GET_ALL_PAYMENT_METHODS:
			return Object.assign({}, state, action.payload);
		case GET_ALL_PAYMENT_METHODS_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		case GET_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case GET_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethod: action.payload.paymentMethod,
			});
		case ADD_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case ADD_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		case UPDATE_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case UPDATE_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		case DELETE_PAYMENT_METHOD:
			return Object.assign({}, state, action.payload);
		case DELETE_PAYMENT_METHOD_SUCCESS:
			return Object.assign({}, state, {
				paymentMethods: action.payload.paymentMethods,
			});
		default:
			return state;
	}
}

export default defaultValues;

